import cx from 'classnames'
import styles from './FilterControlsToggleButton.module.css'
import { IconButton } from '@/components/IconButton'

import { UnreadBadge } from '@/components/UnreadBadge'

interface FilterControlsToggleButtonProps {
  active: boolean
  count: number
  onPress: () => void
}

/**
 * Toggles the filter controls, badged with the number of active filters.
 */
export function FilterControlsToggleButton({
  active,
  count,
  onPress,
}: FilterControlsToggleButtonProps) {
  return (
    <div className={cx(styles.root, active && styles.active)}>
      <IconButton
        name="filter"
        label="Filters"
        inheritColor
        onPress={onPress}
      />
      <div className={styles.badge}>
        {count > 0 && <UnreadBadge count={count} />}
      </div>
    </div>
  )
}
